import { Injectable } from '@angular/core';
import * as moment from 'moment';

@Injectable({
  providedIn: 'root'
})
export class AgendaUtilsService {

  constructor() { }

  constructEventsList(arg: any): any {
    return arg.map((event: any) => (
      {
        CalendarDate: {
          calendarDate: event.CalendarDate,
          weekNumber: moment(event.CalendarDate).week(),
          formattedDate: moment(event.CalendarDate).format('dddd, MMMM DD'),
          relativeDay: moment(event.CalendarDate).diff(moment().startOf('day'), 'days') === 0 ?
            'Today' : moment(event.CalendarDate).diff(moment().startOf('day'), 'days') === 1 ? 'Tomorrow' :
              moment(event.CalendarDate).diff(moment().startOf('day'), 'days') === -1 ? 'Yesterday' :
                moment(event.CalendarDate).from(moment().startOf('day')),
          dayId: moment(event.CalendarDate).format('MMMMDD'),
        },
        EventsForDate: event.EventsForDate.map((elem: any, counter: number) => ({
          ...elem,
          StartTime: moment(this.convertUtcToLocal(elem.StartDateTime)).format('hh:mm A'),
          EndTime: moment(this.convertUtcToLocal(elem.EndDateTime)).format('hh:mm A'),
          isPastEvent: moment(this.convertUtcToLocal(elem.StartDateTime)).isAfter(moment()) ? false : true,
          duration: this.setEventDuration(elem)
        }))
      }));
  }

  convertUtcToLocal(utcDateStr: string): Date {
    // Create a Date object from the UTC string
    const utcDate = new Date(utcDateStr);

    // Get the local time by adjusting for the timezone offset
    const localDate = new Date(utcDate.getTime() - utcDate.getTimezoneOffset() * 60000);

    return localDate;
  }

  private setEventDuration(event: any): string {
    const duration = moment.duration(moment(event.EndDateTime).diff(moment(event.StartDateTime)));
    const hours = Math.floor(duration.asHours());
    const minutes = duration.asMinutes() - hours * 60;

    return `${this.formatDurationTime(hours, 'h')} ${this.formatDurationTime(minutes, 'm')}`.trim()
  }

  private formatDurationTime(value: number, format: string): string {

    return value > 0 ? `${value}${format}` : ''
  }

  setTimeUntilNextEvent(eventsArr: any): void {
    for (const [counter, element] of eventsArr.entries()) {
      if (element.EventsForDate.length !== 0) {
        for (const [index, event] of element.EventsForDate.entries()) {
          if (element.EventsForDate[index + 1]) {
            if (moment.duration(moment(element.EventsForDate[index + 1].StartDateTime).diff(event.StartDateTime)).asHours() < 1) {
              event.TimeUntilNextEvent = moment.duration(moment(element.EventsForDate[index + 1].StartDateTime)
                .diff(event.StartDateTime)).asMinutes() + ' minutes';
            } else {
              event.TimeUntilNextEvent = moment(event.StartDateTime).to(moment(element.EventsForDate[index + 1].StartDateTime), true);
            }
          } else {
            let searchDone = false;
            for (let i = counter + 1; i < eventsArr.length; i++) {
              if (eventsArr[i].EventsForDate.length !== 0 && searchDone === false) {
                if (moment.duration(moment(eventsArr[i].EventsForDate[0].StartDateTime).diff(event.StartDateTime)).asHours() < 1) {
                  event.TimeUntilNextEvent = moment.duration(moment(eventsArr[i].EventsForDate[0].StartDateTime)
                    .diff(event.StartDateTime)).asMinutes() + ' minutes';
                } else {
                  event.TimeUntilNextEvent = moment(event.StartDateTime)
                    .to(moment(eventsArr[i].EventsForDate[0].StartDateTime), true);
                }
                searchDone = true;
              }
            }
          }
        }
      }
    }
  }

  setActiveEvent(eventsArr: any): void {
    for (let i = 0; i < eventsArr.length; i++) {
      // current day does not have events
      if (eventsArr[i].EventsForDate.length === 0 &&
        moment(eventsArr[i].CalendarDate.calendarDate).diff(moment().startOf('day'), 'days') === 0) {
        let isFound = false;
        for (let j = i; j < eventsArr.length; j++) {
          if (eventsArr[j].EventsForDate.length !== 0 && isFound === false) {
            isFound = true;
            eventsArr[j].EventsForDate[0].shouldBeActive = true;
          }
        }
      }
      // current day have events
      if (eventsArr[i].EventsForDate.length !== 0
        && moment(eventsArr[i].CalendarDate.calendarDate).diff(moment().startOf('day'), 'days') === 0) {
        let isFound = false;
        for (const event of eventsArr[i].EventsForDate) {
          if (moment().format('HH:mm').valueOf() <= moment(event.StartDateTime).format('HH:mm').valueOf() && isFound === false) {
            event.shouldBeActive = true;
            isFound = true;
          }
        }
        if (isFound === false) {
          for (let j = i + 1; j < eventsArr.length; j++) {
            if (eventsArr[j].EventsForDate.length !== 0 && isFound === false) {
              isFound = true;
              eventsArr[j].EventsForDate[0].shouldBeActive = true;
            }
          }
        }
      }
    }
  }

  mergeArrayEvents(arr: any): any {
    for (let i = 0; i < arr.length; i++) {
      if (arr[i + 1] &&
        arr[i].CalendarDate.calendarDate === arr[i + 1].CalendarDate.calendarDate) {
        arr[i].EventsForDate = [...arr[i].EventsForDate, ...arr[i + 1].EventsForDate];
        arr.splice(i + 1, 1);
      }
    }
    return arr;
  }
}
